<template>
  <div class="min-h-screen bg-dark text-gray-100">
    <!-- Loading State -->
    <div v-if="authStore.loading" class="min-h-screen flex items-center justify-center">
      <div class="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary"></div>
    </div>

    <!-- Content -->
    <template v-else>
      <admin-layout v-if="authStore.user">
        <router-view />
      </admin-layout>
      <router-view v-else />
    </template>
  </div>
</template>

<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import AdminLayout from '@/components/layout/AdminLayout.vue'

const authStore = useAuthStore()
</script>

<style>
@import '@/assets/main.css';
</style>
